/* eslint jsx-a11y/anchor-is-valid: 0 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import { Carousel } from '@bingads-webui-react/primitive-unthemed';

// Ad Preview
export class AdsPreview extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      index: 0,
      direction: null,
    };
  }

  componentDidMount() {
    this.setAutoRotate();
  }

  setAutoRotate = () => {
    // disable auto-rotate in test
    /* istanbul ignore if */
    if (window.e2eTestEnvironment) {
      return;
    }

    this.clearAutoRotateListener();
    const { index } = this.state;

    const indicators = document.querySelector('.new-preview-carousel-container .carousel-indicators');

    // make sure we have the correct preview to rotate
    const previewCount = (indicators && indicators.childElementCount) || this.props.values.length;
    let nextIndex = index + 1;

    if (nextIndex >= previewCount) {
      nextIndex = 0;
    }

    this.autoRotateListener = setTimeout(() => {
      this.setState({
        index: nextIndex,
        direction: 'next',
      });

      this.setAutoRotate();
    }, 3000);
  }

  clearAutoRotateListener = () => {
    if (this.autoRotateListener) {
      clearTimeout(this.autoRotateListener);
      this.autoRotateListener = null;
    }
  }

  handleSelect = (selectedIndex, e) => {
    this.setState({
      index: selectedIndex,
      direction: e.direction,
    }, () => this.clearAutoRotateListener());
  }

  getLandScapeImageMediaUrl = (imageUrl) => {
    let imageUrlToUse = imageUrl;
    const indexOfResizeInfo = imageUrlToUse.indexOf('&w=');
    if (indexOfResizeInfo > 0) {
      imageUrlToUse = imageUrlToUse.substr(0, indexOfResizeInfo);
    }

    const responsiveAdThumbnailWidth = 114;
    const responsiveAdThumbnailHeight = 60;
    const resizeQueryString = `&w=${responsiveAdThumbnailWidth}&h=${responsiveAdThumbnailHeight}`;

    return `${imageUrlToUse}${resizeQueryString}`;
  }

  render() {
    const { index, direction } = this.state;
    const {
      values,
      i18n,
      headers,
      newI18n,
    } = this.props;

    return (
      <div className="new-preview-carousel-container">
        <div className="ad-preview-header">{_.first(headers)}</div>
        <Carousel
          activeIndex={index}
          direction={direction}
          onSelect={this.handleSelect}
          controls={false}
          nextLabel={i18n.getString('ImageExperience_Ad_Preview_Next')}
          prevLabel={i18n.getString('ImageExperience_Ad_Preview_Previous')}
        >
          {
            values.map(recommendation => (
              <Carousel.Item key={recommendation.OpportunityId}>
                <div className="recommendation-suggested-ads-container">
                  <div className="previewImage">
                    <img
                      src={this.getLandScapeImageMediaUrl(_.first(recommendation.Images).ImageURL)}
                      alt={newI18n.getString(_TL_('Ad Preview Image'))}
                    />
                    {recommendation.Images.length > 1 &&
                      <span className="moreHint">
                        { `+ ${i18n.getString('Recommendation_Grid_Todo_More', { count: recommendation.Images.length - 1 })}` }
                      </span>
                    }
                  </div>
                  <div>
                    <div className="previewTitle">
                      <span className="previewTitleAd">
                        {_.result(_.first(recommendation.Headlines), 'Text')}
                      </span>
                      {recommendation.Headlines.length > 1 &&
                        <span className="moreHint">
                          { `+ ${i18n.getString('Recommendation_Grid_Todo_More', { count: recommendation.Headlines.length - 1 })}` }
                        </span>
                      }
                    </div>
                    <div className="previewText">
                      <span className="previewTextAd">
                        {_.result(_.first(recommendation.Descriptions), 'Text')}
                      </span>
                      {recommendation.Descriptions.length > 1 &&
                        <span className="moreHint">
                          { `+ ${i18n.getString('Recommendation_Grid_Todo_More', { count: recommendation.Descriptions.length - 1 })}` }
                        </span>
                      }
                    </div>
                  </div>
                </div>
              </Carousel.Item>
            ))
          }
        </Carousel>
      </div>
    );
  }
}

AdsPreview.propTypes = {
  headers: PropTypes.arrayOf(PropTypes.string).isRequired,
  values: PropTypes.arrayOf(PropTypes.object).isRequired,
  i18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  newI18n: PropTypes.PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
